import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { from as fromPromise, Observable } from 'rxjs';
import { Action, Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { map, switchMap, take } from 'rxjs/operators';

import { navigateToAction, navigateToSuccessAction, navigateToLastRouteAction } from '@app/store/actions/global.actions';
import { homeRootRoute } from '@home/home-routing.module';
import { State } from '@app/store/state/state';
import { bookingBaseRoute, bookingDetailRoute } from '@booking/constants/booking-routes.constants';

@Injectable()
export class RouterEffect {
  constructor(
    private readonly store: Store<State>,
    private readonly action$: Actions,
    private readonly router: Router
  ) { }

  navigateToAction$: Observable<Action> = createEffect(() => this.action$
    .pipe(
      ofType(navigateToAction),
      switchMap(action => {
        try {
          const commands = this.getCommands(action.commands);
          return fromPromise(
            this.router.navigate(commands, action?.extras)
              .catch(() => this.router.navigate([homeRootRoute]))
          );
        } catch (err) {
          return fromPromise(
            this.router.navigate([homeRootRoute])
          );
        }
      }),
      map(() => navigateToSuccessAction())
    ));

  navigateToLastRoute$: Observable<Action> = createEffect(() => this.action$
    .pipe(
      ofType(navigateToLastRouteAction),
      switchMap(() => this.store.select((state) => state?.routerState?.previousUrl).pipe(take(1))),
      map(previous => {
        return navigateToAction({
          commands: previous?.commands?.length === 0 ? [homeRootRoute] :
            previous?.commands,
          extras: previous?.extras
        });
      }
      )
    ));

  private get currentRoute(): string {
    return this.router.url.split('?')[0];
  }

  private getCommands(commands: Object[]): Object[] {
    return commands.map(commad => {
      const elements = (commad as string).split('/');
      const isBookingInnerOutlet = (commad as string).startsWith(`/${bookingBaseRoute}`) &&
        (commad as string).endsWith(`${bookingDetailRoute}/`) && this.currentRoute.endsWith(`${bookingDetailRoute}`);
      if (isBookingInnerOutlet) {
        elements.pop(); elements.pop();
        return elements.join('/');
      } else return commad;
    });
  }
}
